const URL_BASE = '';

const genericRequest = ({ endpoint }) => {
  return fetch(`${URL_BASE}${endpoint}`)
    .then(response => response.json())
    .catch(err => {
      console.error(err);
    });
};

const genericRequestNoResponse = ({ endpoint }, method) => {
  return fetch(`${URL_BASE}${endpoint}`, { method })
    .catch(err => alert(err));
};

const genericRequestWithBody = ({ endpoint, body }, method) => {
  return fetch(`${URL_BASE}${endpoint}`, {
    method,
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  }).then(response => response.json())
    .catch(err => alert(err));
};

export const requestWithBody = ({ endpoint, body }, method) => {
  return fetch(`${URL_BASE}${endpoint}`, {
    method,
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  });
};

const get = (args) => genericRequest(args);
const post = (args) => genericRequestWithBody(args, 'POST');
const patch = (args) => genericRequestWithBody(args, 'PATCH');
const deleteReq = (args) => genericRequestNoResponse(args, 'DELETE');

export {
  get,
  post,
  patch,
  deleteReq,
  genericRequestNoResponse
};